import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _storeCache;

import { globalConst as native, mutationNames } from 'lib/const';
var CACHE = '_cache';
export var storeCache = (_storeCache = {}, _defineProperty(_storeCache, "".concat(native.readEncryption).concat(CACHE), function _(state) {
  return state.encription !== '';
}), _defineProperty(_storeCache, "".concat(native.readSerial).concat(CACHE), function _(state) {
  return state.serial !== '';
}), _storeCache);
export default storeCache;